import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const BASE_STYLES = {
  primary: {
    muiVariant: 'contained',
    sx: {
      backgroundColor: '#1A56DB',
      color: '#fff',
      borderRadius: '8px',
      fontWeight: 700,
      fontSize: '1.8rem',
      textTransform: 'none',
      padding: '14px 32px',
      boxShadow: '0 4px 14px rgba(26, 86, 219, 0.35)',
      '&:hover': { backgroundColor: '#1648c0' },
    },
  },
  'secondary-dark': {
    muiVariant: 'outlined',
    sx: {
      borderColor: 'rgba(255,255,255,0.7)',
      color: '#fff',
      borderRadius: '8px',
      fontWeight: 700,
      fontSize: '1.8rem',
      textTransform: 'none',
      padding: '14px 32px',
      '&:hover': { borderColor: '#fff', backgroundColor: 'rgba(255,255,255,0.08)' },
    },
  },
  'secondary-light': {
    muiVariant: 'outlined',
    sx: {
      borderColor: '#1A56DB',
      color: '#1A56DB',
      borderRadius: '8px',
      fontWeight: 700,
      fontSize: '1.8rem',
      textTransform: 'none',
      padding: '14px 32px',
      '&:hover': { borderColor: '#1648c0', color: '#1648c0' },
    },
  },
};

function CtaButton({ variant = 'primary', sx, children, to, ...props }) {
  const { muiVariant, sx: baseSx } = BASE_STYLES[variant];
  const button = (
    <Button variant={muiVariant} sx={{ ...baseSx, ...sx }} {...props}>
      {children}
    </Button>
  );
  if (to) {
    return (
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }} onClick={() => window.scrollTo(0, 0)}>
        {button}
      </Link>
    );
  }
  return button;
}

CtaButton.propTypes = {
	variant: PropTypes.any,
	sx: PropTypes.any,
	children: PropTypes.node,
	to: PropTypes.any,
	props: PropTypes.array
};

export default CtaButton;
